import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ArrowBackMobileIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ArrowBackMobileIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ArrowBackMobileIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowBackMobileIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="ArrowBackMobileIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M14.293 4.222a1 1 0 0 1 1.492 1.327l-.078.087L9.343 12l6.364 6.364a1 1 0 0 1 .078 1.327l-.078.087a1 1 0 0 1-1.327.078l-.087-.078-7.071-7.07a1 1 0 0 1-.078-1.328l.078-.087z"
        clipRule="evenodd"
      />
    </svg>
  )
);
ArrowBackMobileIcon.displayName = "ArrowBackMobileIcon";
export default ArrowBackMobileIcon;
